import {
  VictoryBar,
  VictoryChart,
  VictoryTheme,
  VictoryTooltip,
  VictoryZoomContainer,
} from 'victory'

function RatingHistoryChart({ ratingChartData, xZoomDomain, handleDomainChange }) {
  const toggleFillColor = (fill) => {
    if (fill === '#053C5E') {
      return {
        style: {
          fill: '#C3C3C3',
        },
      }
    } else {
      return {
        style: {
          fill: '#053C5E',
        },
      }
    }
  }

  const events = [
    {
      target: 'data',
      eventHandlers: {
        onMouseOver: () => {
          return [
            {
              target: 'data',
              mutation: (props) => toggleFillColor(props.style?.fill),
            },
            {
              target: 'labels',
              mutation: () => ({ active: true }),
            },
          ]
        },
        onMouseOut: () => {
          return [
            {
              target: 'data',
              mutation: (props) => toggleFillColor(props.style?.fill),
            },
            {
              target: 'labels',
              mutation: () => ({ active: false }),
            },
          ]
        },
      },
    },
  ]

  if (!ratingChartData.length)
    return (
      <span
        className="text-center"
        style={{
          backgroundColor: '#053c5e',
          borderRadius: '8px',
          color: 'white',
          fontSize: '14px',
          fontWeight: 500,
          width: '95%',
          marginLeft: 10,
        }}
      >
        Nenhuma avaliação encontrada
      </span>
    )
  else {
    return (
      <VictoryChart
        domainPadding={{ y: 20, x: 0 }}
        domain={{ x: [0, ratingChartData.length + 1] }}
        key={JSON.stringify(ratingChartData)}
        theme={VictoryTheme.clean}
        padding={{ top: 50, bottom: -1, left: -1, right: -1 }}
        containerComponent={
          <VictoryZoomContainer
            allowZoom={false}
            zoomDimension="x"
            allowPan={ratingChartData.length >= xZoomDomain[1] - 1}
            zoomDomain={{ x: xZoomDomain }}
            onZoomDomainChange={(domain) => handleDomainChange(domain)}
          />
        }
      >
        <VictoryBar
          barWidth={20}
          cornerRadius={5}
          data={ratingChartData}
          labelComponent={
            <VictoryTooltip
              cornerRadius={8}
              dy={-5}
              style={{
                fill: '#FFFFFF',
              }}
              flyoutStyle={{
                fill: '#053C5E',
              }}
            />
          }
          labels={({ datum }) => datum.y}
          style={{
            data: {
              fill: '#c3c3c3',
              fillOpacity: 1,
            },
          }}
          events={events}
        />
      </VictoryChart>
    )
  }
}

export default RatingHistoryChart
